export enum IconFace {
  DEFAULT = 'default',
  ACTIVE = 'active',
  DANGER = 'danger',
  BLACK = 'black',
  LIGHT_DANGER = 'light-danger'
}
